module.exports = __webpack_public_path__ + "static/media/pie-chart.99652ca6.png";